import { render, staticRenderFns } from "./CommonDocsTypeList.vue?vue&type=template&id=c792953e&scoped=true&"
import script from "./CommonDocsTypeList.vue?vue&type=script&lang=js&"
export * from "./CommonDocsTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CommonDocsTypeList.vue?vue&type=style&index=0&id=c792953e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c792953e",
  null
  
)

export default component.exports